@if (!isEmbeddedView) {
<aside
  class="sidenav"
  [class.sidenav-collapsed]="!isShow"
  aria-label="Main navigation"
>
  <!-- ── Tenant brand (sticky top) ── -->
  <div class="sidebar-top">
    <div class="sidebar-tenant">
      <div class="tenant-brand" [class.tenant-brand-collapsed]="!isShow">
        <div class="tenant-brand-logo">
          <img [src]="tenantLogoUrl$ | async" alt="" aria-hidden="true" />
        </div>
        @if (isShow) {
        <div class="tenant-brand-divider" aria-hidden="true"></div>
        <div class="tenant-brand-meta">
          <div class="tenant-brand-title-row">
            <!-- <span
              class="tenant-brand-status"
              aria-hidden="true"
              title="Active workspace"
            ></span> -->
            <span class="tenant-brand-name">{{ tenantName }}</span>
          </div>
          <span class="tenant-brand-context">Loyalty workspace</span>
        </div>
        }
      </div>
    </div>
  </div>

  <!-- ── Nav scroll ── -->
  <nav class="nav-scroll" #sidebarMiddle aria-label="Site navigation">
    <!-- Top categories -->
    @for (c of topCategories; track c.name) { @if (c.canShow) { @if (c.subMenu
    && c.subMenu.length) {
    <!-- Group with sub-menu -->
    <div
      class="nav-group"
      [class.is-open]="c.isExpand"
      [class.is-active]="isGroupActive(c)"
    >
      <button
        type="button"
        class="nav-item nav-item-parent"
        [matTooltip]="!isShow ? c.name : ''"
        matTooltipPosition="after"
        (click)="handleAccordion(c)"
      >
        <span class="nav-icon">
          <img
            [src]="'assets/images/sidenav/' + c.icon + '.svg'"
            [alt]="c.name"
          />
        </span>
        @if (isShow) {
        <span class="nav-label">{{ c.name }}</span>
        <span class="nav-chevron" aria-hidden="true"></span>
        }
      </button>
      <div class="nav-sub">
        <div class="nav-sub-inner">
          <ul class="nav-sub-list" role="list">
            @for (subM of c.subMenu; track subM.name) { @if (subM.canShow !==
            false) {
            <li>
              <a
                class="nav-sub-item"
                [routerLink]="'/' + subM.link"
                [class.active]="isRouteActive(subM)"
              >
                {{ subM.name }}
              </a>
            </li>
            } }
          </ul>
        </div>
      </div>
    </div>
    } @else {
    <!-- Simple nav link -->
    <a
      class="nav-item"
      routerLinkActive="active"
      [routerLink]="c.link"
      [matTooltip]="!isShow ? c.name : ''"
      matTooltipPosition="after"
      (click)="closeAllExpansionPanels()"
      #rla="routerLinkActive"
    >
      <span class="nav-icon">
        <img
          [src]="
            'assets/images/sidenav/' +
            (rla.isActive && c.iconActive ? c.iconActive : c.icon) +
            '.svg'
          "
          [alt]="c.name"
        />
      </span>
      @if (isShow) {
      <span class="nav-label">{{ c.name }}</span>
      }
    </a>
    } } }

    <!-- Bottom categories -->
    @for (c of bottomCategories; track c.name) { @if (c.canShow) { @if
    (c.subMenu && c.subMenu.length) {
    <div
      class="nav-group"
      [class.is-open]="c.isExpand"
      [class.is-active]="isGroupActive(c)"
    >
      <button
        type="button"
        class="nav-item nav-item-parent"
        [matTooltip]="!isShow ? c.name : ''"
        matTooltipPosition="after"
        (click)="handleAccordion(c)"
      >
        <span class="nav-icon">
          <img
            [src]="'assets/images/sidenav/' + c.icon + '.svg'"
            [alt]="c.name"
          />
        </span>
        @if (isShow) {
        <span class="nav-label">{{ c.name }}</span>
        <span class="nav-chevron" aria-hidden="true"></span>
        }
      </button>
      <div class="nav-sub">
        <div class="nav-sub-inner">
          <ul class="nav-sub-list" role="list">
            @for (subM of c.subMenu; track subM.name) { @if (subM.canShow !==
            false) {
            <li>
              <a
                class="nav-sub-item"
                [routerLink]="'/' + subM.link"
                [class.active]="isRouteActive(subM)"
              >
                {{ subM.name }}
              </a>
            </li>
            } }
          </ul>
        </div>
      </div>
    </div>
    } @else {
    <a
      class="nav-item"
      routerLinkActive="active"
      [routerLink]="c.link"
      [matTooltip]="!isShow ? c.name : ''"
      matTooltipPosition="after"
      (click)="closeAllExpansionPanels()"
      #rla="routerLinkActive"
    >
      <span class="nav-icon">
        <img
          [src]="
            'assets/images/sidenav/' +
            (rla.isActive && c.iconActive ? c.iconActive : c.icon) +
            '.svg'
          "
          [alt]="c.name"
        />
      </span>
      @if (isShow) {
      <span class="nav-label">{{ c.name }}</span>
      }
    </a>
    } } }
  </nav>

  <!-- ── Platform footer ── -->
  <div class="sidebar-platform" role="contentinfo">
    <div class="sidebar-platform-inner">
      @if (isShow) {
      <span class="sidebar-platform-label">Powered by</span>
      }
      <img
        class="sidebar-platform-icon"
        src="assets/images/sidenav/jioloyalty_logo.svg"
        alt="JioLoyalty"
      />
    </div>
  </div>
</aside>

<!-- ── Collapse/expand toggle on the sidebar seam ── -->
<button
  type="button"
  class="sidebar-toggle"
  [matTooltip]="isShow ? 'Collapse' : 'Expand'"
  matTooltipPosition="after"
  [attr.aria-label]="isShow ? 'Collapse sidebar' : 'Expand sidebar'"
  (click)="toggleMe()"
>
  <span class="sidebar-toggle-chevron" aria-hidden="true"></span>
</button>
}
